// import { Navigate } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";

// const ProtectedRoute = ({ children }) => {
//   const { currentUser, loading } = useAuth();

//   if (loading) return <div>Loading...</div>;

//   if (!currentUser) {
//     return <Navigate to="/login" />;
//   }

//   return children;
// };

// export default ProtectedRoute;



import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // Wait until auth loads
  if (loading) return null;

  // Redirect if not logged in
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;